import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FaHome, FaUser, FaPhone } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('navbar-expanded', expanded);
  }, [expanded]);

  const collapseNavbar = () => setExpanded(false);
  const toggleNavbar = () => setExpanded(exp => !exp);

  const isActive = (path) => location.pathname === path;

  return (
    <Navbar expanded={expanded} className={scrolled ? 'navbar-scrolled' : 'navbar'} expand="lg" fixed="top">
      <Navbar.Brand as={Link} to="/" onClick={collapseNavbar}>
        <img src="./Loggo.png" alt="Logo" className="navbar-logo" />
      </Navbar.Brand>
      <Navbar.Toggle onClick={toggleNavbar} aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="m-auto">
          <Nav.Link as={Link} to="/" onClick={collapseNavbar}><FaHome /> Home</Nav.Link>
          <NavDropdown title="About" id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/about#mission">Mission</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/about#vision">Vision</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/about#core-values">Core Values</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/about#quality-policy">Quality Policy</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Services" id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/services#full-stack">Full Stack Website Development</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services#static">Static Website Design</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services#cv">Online CV Creation</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services#portfolio">Portfolio Development</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Projects" id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/projects#full-stack">Full Stack Websites</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/projects#static">Static Websites</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/projects#cv">Online CVs</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/projects#portfolio">Portfolios</NavDropdown.Item>
          </NavDropdown>
          <Nav.Link as={Link} to="/team" onClick={collapseNavbar}><FaUser /> Team</Nav.Link>
          <Nav.Link as={Link} to="/contact" onClick={collapseNavbar}><FaPhone /> Contact</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;